export enum OutwardStatus{
    Returnable = 1,
    NonReturnable = 2,
    InternalMovement = 3,
    Created = 4,
    LAapprover1 = 5,
    LAapprover2 = 7,
    Supervisor = 8,
    PrintPass = 9,
    Received = 10,
    Declined = 11,
    Cancelled = 12
}
export enum OutwardStatusName{
    Created = 'Created',
    LAapprover1 = 'LA approved 1',
    LAapprover2 = 'LA Approved 2',
    Supervisor = 'Supervisor Approved',
    PrintPass = 'Print pass',
    Received = 'Received',
    Declined = 'Declined',
    Cancelled = 'Cancelled'
}
